import React from 'react';
import { Shield } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-dark-base py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <Shield className="h-12 w-12 text-primary mx-auto mb-4" />
          <h1 className="text-3xl font-bold text-white">Política de Privacidad</h1>
          <p className="mt-2 text-gray-400">Última actualización: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="prose prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Información que Recopilamos</h2>
            <p className="text-gray-300">
              Recopilamos la siguiente información cuando utilizas nuestra plataforma:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Información de registro (email)</li>
              <li>Datos de uso de la plataforma</li>
              <li>Información técnica (dirección IP, tipo de navegador)</li>
              <li>Cookies y tecnologías similares</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Uso de la Información</h2>
            <p className="text-gray-300">
              Utilizamos la información recopilada para:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Proporcionar y mantener nuestros servicios</li>
              <li>Mejorar y personalizar tu experiencia</li>
              <li>Comunicarnos contigo sobre actualizaciones o cambios</li>
              <li>Detectar y prevenir fraudes</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. Tus Derechos GDPR</h2>
            <p className="text-gray-300">
              Bajo el Reglamento General de Protección de Datos (GDPR), tienes los siguientes derechos:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Derecho de acceso a tus datos personales</li>
              <li>Derecho de rectificación</li>
              <li>Derecho de supresión ("derecho al olvido")</li>
              <li>Derecho a la limitación del tratamiento</li>
              <li>Derecho a la portabilidad de los datos</li>
              <li>Derecho de oposición</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Cookies</h2>
            <p className="text-gray-300">
              Utilizamos cookies y tecnologías similares para:
            </p>
            <ul className="list-disc list-inside text-gray-300 mt-2">
              <li>Mantener tu sesión activa</li>
              <li>Recordar tus preferencias</li>
              <li>Analizar el uso de nuestra plataforma</li>
              <li>Mejorar nuestros servicios</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Contacto</h2>
            <p className="text-gray-300">
              Para cualquier consulta sobre privacidad o ejercer tus derechos GDPR, contáctanos en:{' '}
              <a href="mailto:info@asistentetradingia.com" className="text-primary hover:text-primary-hover">
                info@asistentetradingia.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;